import { __rest as e } from "tslib";
import * as t from "react";
import r from "classnames";
import { classNameModifier as i } from "../shared/utils.js";
import { ComponentClassNames as o } from "../shared/constants.js";
import { splitPrimitiveProps as s } from "../shared/styleUtils.js";
import "../Field/FieldClearButton.js";
import { FieldDescription as n } from "../Field/FieldDescription.js";
import { FieldErrorMessage as a } from "../Field/FieldErrorMessage.js";
import { FieldGroup as l } from "../FieldGroup/FieldGroup.js";
import { Flex as d } from "../Flex/Flex.js";
import { Input as m } from "../Input/Input.js";
import { Label as p } from "../Label/Label.js";
import { isTextAreaField as c, isTextAreaRef as f, isInputField as u, isInputRef as h } from "./utils.js";
import { TextArea as b } from "../TextArea/TextArea.js";
import { useStableId as E } from "../utils/useStableId.js";
import { useDeprecationWarning as g } from "../../hooks/useDeprecationWarning.js";

var j = 3,
    F = function F(j, _F) {
  var x = j.className,
      C = j.descriptiveText,
      v = j.errorMessage,
      _j$hasError = j.hasError,
      y = _j$hasError === void 0 ? !1 : _j$hasError,
      S = j.id,
      T = j.label,
      _j$labelHidden = j.labelHidden,
      w = _j$labelHidden === void 0 ? !1 : _j$labelHidden,
      M = j.outerEndComponent,
      I = j.outerStartComponent,
      z = j.innerStartComponent,
      H = j.innerEndComponent,
      N = j.isMultiline,
      A = j.type,
      L = j.size,
      O = j.testId,
      P = j.variation,
      D = j.bottom,
      G = j.height,
      W = j.left,
      k = j.padding,
      B = j.position,
      R = j.right,
      U = j.top,
      q = j.width,
      J = e(j, ["className", "descriptiveText", "errorMessage", "hasError", "id", "label", "labelHidden", "outerEndComponent", "outerStartComponent", "innerStartComponent", "innerEndComponent", "isMultiline", "type", "size", "testId", "variation", "bottom", "height", "left", "padding", "position", "right", "top", "width"]),
      K = E(S),
      Q = E(),
      V = C ? Q : void 0,
      _s = s(J),
      X = _s.flexContainerStyleProps,
      Y = _s.baseStyleProps,
      Z = _s.rest;

  g({
    shouldWarn: j.isMultiline,
    message: "TextField isMultiLine prop will be deprecated in next major release of @aws-amplify/ui-react. Please use TextAreaField component instead."
  });
  var $ = null;

  if (c(j)) {
    var _e = j.rows;
    $ = t.createElement(b, Object.assign({
      "aria-describedby": V,
      hasError: y,
      id: K,
      ref: f(j) ? _F : void 0,
      rows: null != _e ? _e : 3,
      size: L,
      variation: P
    }, Y, Z));
  } else if (u(j)) {
    var _j$type = j.type,
        _e2 = _j$type === void 0 ? "text" : _j$type;

    $ = t.createElement(m, Object.assign({
      "aria-describedby": V,
      hasError: y,
      id: K,
      ref: h(j) ? _F : void 0,
      size: L,
      type: _e2,
      variation: P
    }, Y, Z));
  }

  return t.createElement(d, Object.assign({
    className: r(o.Field, i(o.Field, L), o.TextField, x),
    bottom: D,
    "data-size": L,
    height: G,
    left: W,
    padding: k,
    position: B,
    right: R,
    testId: O,
    top: U,
    width: q
  }, X), t.createElement(p, {
    htmlFor: K,
    visuallyHidden: w
  }, T), t.createElement(n, {
    id: Q,
    labelHidden: w,
    descriptiveText: C
  }), t.createElement(l, {
    outerStartComponent: I,
    outerEndComponent: M,
    innerStartComponent: z,
    innerEndComponent: H,
    variation: P
  }, $), t.createElement(a, {
    hasError: y,
    errorMessage: v
  }));
},
    x = t.forwardRef(F);

F.displayName = "TextField";
export { j as DEFAULT_ROW_COUNT, x as TextField };